export default () => {
    return (
        <div class="flex h-screen">
            <img
                className="w-full h-full object-cover relative"
                src="/assets/personal-training-locatie-uden.jpg"
                alt="Personal training locatie Uden"
            />
            <div class="m-auto absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <h1 className="text-center text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-xxl">
                    <span className="text-we-are-yellow">We </span>
                    <span className="text-we-are-purple">Are</span>
                </h1>
                <p className="text-center text-white font-custom italic font-bold uppercase  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl sm:text-7xl">
                    Thankful
                </p>
                <p className="mt-5 text-xl text-gray-100 text-center">
                    Bedankt voor de aanschaf van het programma "In shape voor de
                    zomer"!
                </p>
            </div>
        </div>
    );
};
